import { ApplicationConstants } from 'constants/application';
import { createAction } from 'redux-actions';

export const getApplications = createAction(ApplicationConstants.FETCH_APPLICATION_LIST);
export const downloadJSONFromPresign = createAction(ApplicationConstants.DOWNLOAD_JSON_FROM_PRESIGN);
export const getOffers = createAction(ApplicationConstants.FETCH_OFFERS_LIST);
export const getApplicationFilters = createAction(ApplicationConstants.FETCH_APPLICATION_FILTERS);
export const updateApplication = createAction(ApplicationConstants.PATCH_APPLICATION);
export const uploadDocuments = createAction(ApplicationConstants.UPLOAD_DOCUMENTS);
export const getMerchantDetail = createAction(ApplicationConstants.FETCH_MERCHANT_DETAIL);
export const resendEmail = createAction(ApplicationConstants.RESEND_EMAIL);
export const getStats = createAction(ApplicationConstants.GET_STATS);
export const getRefundReasons = createAction(ApplicationConstants.GET_REFUND_REASONS);
export const getActiveContract = createAction(ApplicationConstants.GET_ACTIVE_CONTRACT);
export const refundRequest = createAction(ApplicationConstants.REFUND_REQUEST);
export const getFeatures = createAction(ApplicationConstants.GET_FEATURES);
export const getDepositRefunds = createAction(ApplicationConstants.GET_DEPOSIT_REFUNDS);
export const getTestValuesData = createAction(ApplicationConstants.GET_TEST_VALUES_DATA);



// WEBPACK FOOTER //
// ./src/actions/application.js